<template>
  <section class="hero is-bold app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <div class="hero-head">
      <nav class="nav">
        <div class="nav-left">
          <a class="nav-item is-hidden-tablet" @click="toggleSidebar(!sidebar.opened)">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
        <div class="nav-center">
          <input type="file" ref="fileselector" v-show="false" @change="onFileSelected" >
          <p class="nav-item hero-brand" href="/">
            <label @click="editTitle" v-show="!edit_project_name"> PROJECT:
              <span>{{ this.$store.state.project.project_name }}</span>
              <span v-if="this.$store.state.project.project_name === ''" class="tag is-danger is-small">NO PROJECT NAME</span>
            </label>
          </p>
          <div class="nav-item" v-if="edit_project_name">
            <span><p>Edit Project Name: &nbsp;&nbsp;</p></span>
            <div class="control has-addons">
              <button @click="editTitleCancel" class="button is-small is-outlined"><i class="fa fa-times"></i></button>
              <input type="text" class="input is-small" v-model="temp_project_name"> 
              <button @click="editTitleUpdate" class="button is-small is-success is-outlined"><span class="icon is-small"><i class="fa fa-check"></i></span></button>
            </div>
          </div>
        </div>
        <div class="nav-right nav-menu">
          <div class="nav-item">
            <tooltip :label="this.$store.state.project.local_save_working ? 'Autosave successful' : 'Autosave failing'" placement="left">
              <span class="icon is-small" :style="{ color: this.$store.state.project.local_save_working ? '#00d1b2' : '#ff3860' }">
                <i class="fa fa-circle"></i>
              </span>
            </tooltip>
            </div>
          <div class="nav-item">
            <span class="nav-item button is-small" @click="loadStateFile">
              <span class="icon is-small">
                <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
              </span>&nbsp;
              LOAD FROM FILE
            </span>
            <span class="nav-item button is-small" @click="saveStateFile">
              <span class="icon is-small">
                <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
              </span>&nbsp;
              SAVE TO FILE
            </span>
          </div>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
import Tooltip from "vue-bulma-tooltip";
import { mapGetters, mapActions } from "vuex";
import FileSaver from "file-saver";
import Blob from 'blob';

export default {
  data: function() {
    return {
      edit_project_name: false,
      temp_project_name: this.$store.state.project.project_name
    };
  },

  components: {
    Tooltip
  },

  props: {
    show: Boolean
  },

  computed: mapGetters({
    pkginfo: "pkg",
    sidebar: "sidebar"
  }),

  methods: {
    ...mapActions([
      "toggleSidebar",
      "createNewProject",
      "loadProjectFile",
      "updateProjectName"
    ]),

    loadStateFile: function() {
      this.$refs.fileselector.click();
    },

    onFileSelected: function(e) {
      this.loadProjectFile(e.target.files[0]);
      e.preventDefault();
    },

    saveStateFile: function() {
      const {operation_list, upload_files_pending, upload_warnings, redooperation_list, lastNodeIdAdded, local_save_working, valid_file_types, ...saveStuff} = this.$store.state.project

      var blob = new window.Blob([JSON.stringify(saveStuff)], {
        type: "text/plain;charset=utf-8"
      });
      FileSaver.saveAs(
        blob,
        "project-" + this.$store.state.project.project_name + ".json"
      );
    },

    editTitle: function(e) {
      this.$data.edit_project_name = true;
    },

    editTitleCancel: function(e) {
      this.$data.edit_project_name = false;
      this.$data.temp_project_name = this.$store.state.project.project_name;
    },

    editTitleUpdate: function(e) {
      this.updateProjectName(this.$data.temp_project_name);
      this.$data.edit_project_name = false;
    }
  }
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";

.app-navbar {
  position: fixed;
  min-width: 100%;
  z-index: 1024;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

  .container {
    margin: auto 10px;
  }

  .nav {
    align-items: stretch;
    display: flex;
    min-height: 50px;
    position: relative;
    text-align: center;
    z-index: 2
  }

  .nav-left {
    align-items: stretch;
    display: flex;
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }

  .nav-right {
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    display: flex;
  }

  .nav-center {
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    align-items: stretch;
    display: flex;
  }
  
  .nav-item {
    align-items: center;
    display: flex;
    flex-grow: 0;
    justify-content: center;
    padding: 10px;
    flex-shrink: 0;
    .button+.button {
      margin-left: 10px;
    }
  }
  .button.is-small {
    border-radius: 2px;
    font-size: 11px;
    height: 24px;
    line-height: 16px;
    padding-left: 6px;
    padding-right: 6px;
  }
  .icon.is-small {
    display: inline-block;
    text-align: center;
    vertical-align: top;
    font-size: 14px;
    height: 16px;
    line-height: 16px;
    width: 16px;
  }
  .icon:last-child {
    margin-left: 4px !important;
    margin-right: -2px !important;
  }
}

.hero-brand {
  .vue {
    margin-left: 10px;
    color: #36ac70;
  }
  .admin {
    color: #28374b;
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?0f993865